import createModel from 'utils/model'
import {detail, followUsers, customerChats} from 'crm/services/customer-info'

export default createModel({
    namespace: 'crm_customerInfo',
    state: {},

    subscriptions: {},

    effects: {
        *detail({payload}, {call}) {
            return yield call(detail, payload)
        },
        *followUsers({payload}, {call}) {
            return yield call(followUsers, payload)
        },
        *customerChats({payload}, {call}) {
            return yield call(customerChats, payload)
        },
    },
    reducers: {},
})
